import Auth from "@/utils/authing";
import HTTP from "@/utils/http";
export default {
  namespaced: true,
  state: {
    userInfo: {},
    isLogin: false
  },
  mutations: {
    SET_USERINFO(state, userInfo) {
      state.userInfo = userInfo;
    },
    SET_ISLOGIN(state, isLogin) {
      state.isLogin = isLogin;
    }
  },
  actions: {
    async login({ commit }, { eventName = "login", params }) {
      const userInfo = await Auth({
        eventName: eventName,
        params: [params.account, params.password]
      });
      if (!userInfo) return;

      commit("SET_USERINFO", userInfo);
      window.sessionStorage.setItem(
        "MASS_WALLET_USERINFO",
        JSON.stringify(userInfo)
      );
      window.sessionStorage.setItem("MASS_WALLET_Token", userInfo.token);
      window.sessionStorage.setItem(
        "MASS_WALLET_Token_ExpiredAt",
        userInfo.tokenExpiredAt
      );
    },
    /* eslint-disable */
    register({}, { eventName = "register", params }) {
      return Auth({ eventName, params: [params.p1, params.p2, params.p3] });
    },
    resetPassword({}, { eventName = "resetPasswordByPhoneCode", params }) {
      return Auth({ eventName, params: [params.p1, params.p2, params.p3] });
    },
    sendSmsCode({}, params) {
      return Auth({
        eventName: "sendSmsCode",
        params: [params.account]
      });
    },
    sendEmailCode({}, params) {
      return Auth({
        eventName: "sendEmail",
        params: [params.account],
        scene: params.scene
      });
    },
    logout({commit}) {
      commit("SET_USERINFO", {});
      window.sessionStorage.removeItem("MASS_WALLET_USERINFO");
      window.sessionStorage.removeItem("MASS_WALLET_Token");
      window.sessionStorage.removeItem("MASS_WALLET_Token_ExpiredAt");
      commit("SET_ISLOGIN", false);
    },

    /* eslint-disable */
    async walletLogin({ commit }) {
      await HTTP({ method: "get", url: "/user/login" });
      commit("SET_ISLOGIN", true);
    }
  }
};
